import * as React from 'react';

const CalendarIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    id='BeBold'
    width={'1em'}
    height={'1em'}
    viewBox='0 0 14 14'
    {...props}
  >
    <defs>
      <style>{'.cls-1{fill:currentColor;fill-rule:evenodd}'}</style>
    </defs>
    <g id='Date'>
      <path
        d='M3.5 3.469a.882.882 0 0 0 .882-.883V.994a.882.882 0 1 0-1.764 0v1.592a.882.882 0 0 0 .882.883ZM10.5 3.469a.882.882 0 0 0 .882-.883V.994a.882.882 0 1 0-1.764 0v1.592a.882.882 0 0 0 .882.883Z'
        className='cls-1'
      />
      <path
        d='M12.668 1.292v1.455a2.254 2.254 0 0 1-1.944 2.281 2.168 2.168 0 0 1-2.391-2.157V1.644a.36.36 0 0 0-.36-.359H6.027a.359.359 0 0 0-.359.359v1.1a2.254 2.254 0 0 1-1.944 2.284 2.168 2.168 0 0 1-2.391-2.157V1.292A1.4 1.4 0 0 0 0 2.685v9.8a1.4 1.4 0 0 0 1.4 1.4h11.2a1.4 1.4 0 0 0 1.4-1.4v-9.8a1.4 1.4 0 0 0-1.332-1.393ZM11.5 10.775a.855.855 0 0 1-.852.852h-7.5a.855.855 0 0 1-.852-.852v-3.32a.855.855 0 0 1 .855-.855h7.5a.855.855 0 0 1 .852.852Z'
        className='cls-1'
      />
    </g>
  </svg>
);
export default CalendarIcon;
